import { ApiService }        from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';
import { SessionService }    from '../../app-lite/sessions/session.service';

import RemindersHtml from './messages.reminders.html';

export function MessagesStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'RemindersCtrl',
    name       : 'app.reminders',
    templateUrl: RemindersHtml,
    url        : '/reminders',
    resolve    : {
      company        : ( workshopAPI : ApiService ) => workshopAPI.get('/company'),
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      session        : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  });
}